<template>
  <div class="Details Services boddy">
    <Navbar title="Yajobici" />

    <div class="" style="margin-top: 80px !important">

      <div
        class="page-header mb-5 p-5"
        style="background-color: #61c7f2 !important"
      >
        <div class="container pt-3 pb-4">
          <h2 class="text-white mb-2 animated slideInDown">Contactez-nous</h2>
        </div>
      </div><!-- end page header -->

      <!-- Contact start-->
      <div class="container-fluid">
        <div class="container">


          <div class="container-xxl py-5">

            <div class="container">

              <div class="row g-5">

                <h1 class="display-5 text-center">Avez-vous des quesions ?</h1>
                <p class="text-center m-0">
                  N'hesitez pas à nous contacter et laisser un message ici.
                </p>

                <!-- part 1 start -->
                <div
                  class="col-lg-6 wow fadeIn"
                  data-wow-delay="0.1s"
                  style="
                    visibility: visible;
                    animation-delay: 0.1s;
                    animation-name: fadeIn;
                  "
                >

                  <p
                    class="d-inline-block border rounded fw-semi-bold py-1 px-3"
                    style="color: #f7a51b; border-radius: 5px !important"
                  >
                    Contact
                  </p>
                  
                  <form @submit.prevent="submitContactUsForm">
                    <div class="row g-3">
                      <div class="col-md-6">
                        <div class="form-floating">
                          <input
                            type="email"
                            class="form-control"
                            id="email"
                            placeholder="Email"
                            v-model="email"
                            required
                          />
                          <label for="email">Adresse email</label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="phone_number"
                            placeholder="Numero de téléphone"
                            v-model="phone"
                            required
                          />
                          <label for="phone_number">Numero de téléphone</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating">
                          <input
                            type="text"
                            class="form-control"
                            id="subject"
                            placeholder="sujet"
                            v-model="subject"
                            required
                          />
                          <label for="subject">Sujet</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-floating">
                          <textarea
                            class="form-control"
                            placeholder="Ecrivez ici"
                            id="message"
                            style="height: 100px"
                            v-model="message"
                            required
                          ></textarea>
                          <label for="message">Message</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <button
                          class="btn py-3 px-5 disabled"
                          style="
                            background-color: #61c7f2;
                            color: #ffffff;
                            border-radius: 5px !important;
                          "
                          type="submit"
                          v-if="loading"
                        >
                          Operation en cours ...
                        </button>
                        <button
                          class="btn py-3 px-5"
                          style="
                            background-color: #61c7f2;
                            color: #ffffff;
                            border-radius: 5px !important;
                          "
                          type="submit"
                          v-else
                        >
                          Envoyer
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- part 1 end -->

                <!-- Part 2 START -->
                  <div
                    class="col-lg-6 wow fadeIn"
                    data-wow-delay="0.5s"
                    style="
                      min-height: 450px;
                      visibility: visible;
                      animation-delay: 0.5s;
                      animation-name: fadeIn;
                    "
                  >
                  
                    <div v-if="compsettings" class="row mb-5 pt-5">
                      
                      <!-- Tel (start) -->
                      <!-- <div class="d-flex align-items-center mb-4">
                          <div class="Cercle">
                            <div class="bg-prim btn-lg-square rounded-circle p-2">
                              <i class="fa fa-phone-alt text-white"></i>
                            </div>
                          </div>
                          <div class="ms-4">
                              <h6>Mobile</h6>
                              <p class="mb-0">+{{ compsettings.phone }}</p>
                          </div>
                      </div> -->
                      <!-- Tel (end) -->

                      <!-- email (start) -->
                      <div class="d-flex align-items-center mb-4">
                          <div class="Cercle">
                            <div class="bg-prim btn-lg-square rounded-circle p-2">
                              <i class="fa fa-envelope-open text-white"></i>
                            </div>
                          </div> 
                          <div class="ms-4">
                              <h6>E-mail</h6>
                              <p class="mb-0">{{ compsettings.email }}</p>
                          </div>
                      </div>
                      <!-- email (end) -->

                      <!-- Adresse (start)-->
                      <div class="d-flex align-items-center mb-4">
                          <div class="Cercle">
                            <div class="bg-prim btn-lg-square rounded-circle p-4">
                              <i class="fa fa-home text-white"></i>
                            </div>
                          </div>
                          <div class="ms-4">
                              <h6>Adresse</h6>
                              <p class="mb-0">{{ compsettings.addresse }}</p>
                          </div>
                      </div>
                      <!-- Adresse (end)-->

                      <!-- liens sociaux (start) -->
                        <div class="d-flex align-items-center pt-3">
                            <div class="me-4">
                                <div class="d-flex align-items-center justify-content-center" 
                              >
                                  <i class="iicon fas fa-share fa-3x text-primary" style="color: #61c7f2 !important;"></i>
                                </div>
                            </div>
                            <div class="d-flex">
                                <a :href="compsettings.facebook_url" target="_blank" class="btn btn-secondary border-secondary me-2 p-0">facebook <i class="fas fa-chevron-circle-right"></i></a>
                                <a :href="'https://wa.me/' + compsettings.phone"  target="_blank" class="btn btn-secondary border-secondary mx-2 p-0">WhatsApp <i class="fas fa-chevron-circle-right"></i></a>
                            </div>
                        </div>
                      <!-- liens sociaux (start) -->
                    </div>

                    <div v-else>
                      <p style="color: transparent !important;">Chargement des informations...</p>
                    </div>

                  </div>
                <!-- part 2 end -->

              </div>

              <!-- section map end -->
               <div
                  class="col-lg-12 wow fadeIn"
                  data-wow-delay="0.5s"
                  style="
                    min-height: 450px;
                    visibility: visible;
                    animation-delay: 0.5s;
                    animation-name: fadeIn;
                  "
                >
                  <div class="position-relative rounded overflow-hidden h-100">
                    <iframe
                      class="position-relative w-100 h-100"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127118.32333851764!2d-4.049877337508402!3d5.348446107419886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1ea5311959121%3A0x3fe70ddce19221a6!2sAbidjan!5e0!3m2!1sfr!2sci!4v1664884609047!5m2!1sfr!2sci"
                      frameborder="0"
                      style="min-height: 450px; border: 0; border-radius: 15px !important;"
                      allowfullscreen=""
                      aria-hidden="false"
                      tabindex="0"
                    ></iframe>
                  </div>
               </div>
              <!-- section map end -->
              

            </div>

          </div>

        </div>

      </div>
      <!-- Contact End -->

    

    </div> <!-- div = body end -->

  </div>
</template>

<script>
import Navbar from "../../components/Navbar.vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
export default {
  name: "ContactUs",
  components: {
    Navbar
  },
  computed: {
    compsettings() {
      return this.$store.state.staticdata.compsettings;
    },
    loadingCompsettings() {
      return this.$store.state.staticdata.loadingCompsettings;
    },
    errorCompsettings() {
      return this.$store.state.staticdata.errorCompsettings;
    }
  },
  created() {
    this.$store.dispatch("staticdata/fetchCompSetting");
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      loading: false,
      email: "",
      phone: "",
      subject: "",
      message: "",
      apimessage: "",
    };
  },
  methods: {
    async submitContactUsForm() {
      this.loading = true;
      var data = {
        email: this.email,
        phone: this.phone,
        subject: this.subject,
        message: this.message,
      };
      console.log(data, " data");
      await this.$store.dispatch("user/contactUsRequest", data).then(
        (response) => {
          this.loading = false;
          this.toast.success(response.message, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
        },
        (error) => {
          this.loading = false;
          this.apimessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.loading = false;

          Swal.fire({
            title: "Oups :)",
            text:
              (error.response &&
                error.response.data &&
                error.response.data.message +
                  " " +
                  JSON.stringify(error.response.data.data)) ||
              error.data ||
              error.message ||
              error.toString(),
            icon: "error",
          });
        }
      );
    },
  },
};
</script>

<style scoped>
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #555;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dfe4fd;
  appearance: none;
  border-radius: 8px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control:focus{
box-shadow: 0 0 0 .25rem rgba(4, 146, 254, 0.25) !important;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.bg-prim{
  background-color: #61c7f2 !important;
}
.ms-4 h6{
  color: #F7A51B !important;
}
.ms-4 p{
  color: #61c7f2 !important;
}
.Cercle{
  padding: 2% !important;
  background: transparent !important;
  border: 1px solid #61c7f2;
  border-radius: 50% !important;
}
</style>
